import React,{ Component } from 'react';
import _, { isEmpty, size } from 'lodash';
import Moment from 'react-moment';

import NewFormRegestering from '../module/NewFormRegestering.jsx';
import PopupInfo from '../paygPopupInfo';
import Pagination from '../../../commonModules/interface/Pagination';
import Notif from '../../../commonModules/interface/Notif';
import EditForm from './EditForm.jsx';
import PopUp from '../../../commonModules/interface/PopUp.jsx';
import { connect } from 'react-redux';
import { TableLayout } from '../Stock/containers/Layout.jsx';
import { TableRow, TableCell, TableBody, IconButton, TableHead } from '@material-ui/core';
import { EditRounded, CheckRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../commonModules/interface/TableFooterPagination.jsx';
import { COLORS } from '../paygResumeInfoList.jsx';
import RichText from '../../../commonModules/interface/RichText.jsx';


function toClassState(data) {
    var val = "";
    switch(data){
      case "Résolu":
        val = "success";
        break;
      case "En attente de validation":
        val = "danger";
        break;
      case "En attente":
        val = "warning";
        break;
     case "En cours de traitement":
        val = "info";
        break;
      default:
         console.log('[ERROR], toClassState, no value ,',data);
    }
    return val;
  }

class ReportsList extends Component {
    
    state = {
        active:"all",
        edit: false,
        showPopup: false,
        popupSchema:false,
        reportID: '',
        reportIDList: this.props.reportIDList,
        boxOwnersIds: {},
        commentClass: 'form-group fg-float',
        commentFocus: false,
        comment: '',
        status: '',
        selected_report: {},

        sortByPaygoID: 'sorting',
        sortByMood: 'sorting',
        sortByStatus: 'sorting',
        sortByCreation: 'sorting',
        sortByUpdate: 'sorting_desc',
        sortByComment: 'sorting',

        sort: false,
        notif:{
            type:"", 
            message:"",
            show: false
        },
        schemasList:[]
    };
    componentWillMount= async() => {
        try {
            this.sortBy("timeUpdate");
            // this.sortByUpdate();
            
        } catch (err) {
            console.log(err);
        }
        this.getTechSchemas();
    }
    
    componentWillReceiveProps(nextProps) {
        // console.log('nextProps in Reports : ', nextProps.reportIDList);
        this.setState({ 
            reportIDList: nextProps.reportIDList, 
            sort: !this.state.sort,
            sortByPaygoID: 'sorting',
            sortByMood: 'sorting',
            sortByStatus: 'sorting',
            sortByCreation: 'sorting',
            sortByUpdate: 'sorting',
            sortByComment: 'sorting',
        });
    }
    edit = boxReport => {
        this.setState({ 
            edit: true, 
            reportID: boxReport.id, 
            status: '', 
            comment: '', 
            selected_report: boxReport 
        });
    }
    onEdit = (updated_item) => {
        this.props.updateReport(updated_item);
        this.props.filterFct()
        // let list = this.sortByDateReverse()
        this.setState({
            edit: false,
            // sortByUpdate: "sorting_asc",
            // reportIDList: list,
        });
        this.sortBy("timeUpdate", true)
    }

    // sortByDate(list, field = 'date') {
    //     list.sort((a, b) => {
    //         return new Date(a[field]) - new Date(b[field])
    //     });

    //     return list
    // }  
    sortByDateReverse = ( field = 'timeUpdate') => {
        const { REPORTS } = this.props
        let list = this.state.reportIDList
        list.sort((box1, box2) => {
            return new Date(REPORTS[box2][field]) - new Date(REPORTS[box1][field])
        });

        return list
    }  
    sortBy = ( field, reload = false ) => { // after submit
        const { REPORTS } = this.props
        let list = this.state.reportIDList
        let newSortValue = 'sorting_desc';
        let sortedList = []

        const sortName = {
            "labels": "sortByStatus",
            "paygoId": "sortByPaygoID",
            "Mood": "sortByMood",
            // "labels": "sortByStatus",
            "timeCreation": "sortByCreation",
            "timeUpdate": "sortByUpdate",
            "comments": "sortByComment",
        }
        const byDate = [
            "timeCreation",
            "timeUpdate",
        ]
        
        sortedList = list.sort( (box1, box2) => {
            let item1 = REPORTS[box1][field]
            let item2 = REPORTS[box2][field]

            if(byDate.includes(field)){
                item1 = new Date(item1);
                item2 = new Date(item2);
            } else if(field === "Mood"){
                item1 = item1[0].val.toUpperCase()
                item2 = item2[0].val.toUpperCase()

            } else if(field === "comments"){
                item1 = item1 ? item1[item1.length - 1].comment.toUpperCase() : ""
                item2 = item2 ? item2[item2.length - 1].comment.toUpperCase() : ""

            } else if(field === "labels"){
                item1 = item1 ? item1[item1.length - 1].val.toUpperCase() : ""
                item2 = item2 ? item2[item2.length - 1].val.toUpperCase() : ""

            } else if(field === "paygoId"){
                item1 = item1.toUpperCase()
                item2 = item2.toUpperCase()
            }

            if (reload || this.state[sortName[field]] === 'sorting_desc') {
                newSortValue = 'sorting_asc';
                // return item2 - item1;
                if (item1 > item2) {
                    return -1;
                } else if (item1 < item2) {
                    return 1;
                }
                return 0;
            } else if (this.state[sortName[field]] === 'sorting' || this.state[sortName[field]] === 'sorting_asc') {
                // return item1 - item2;
                if (item2 > item1) {
                    return -1;
                } else if (item2 < item1) {
                    return 1;
                }
                return 0;
            } 
        });

        this.setState({
            reportIDList: sortedList,
            sortByPaygoID: 'sorting',
            sortByMood: 'sorting',
            sortByStatus: 'sorting',
            sortByCreation: 'sorting',
            sortByUpdate: 'sorting',
            sortByComment: 'sorting',
            [sortName[field]]: newSortValue,
            sort: !this.state.sort,
        })
    }
    
    validateChanges = () => {
        const { reportIDList, reportID, comment, status } = this.state;
        let modifiedList = reportIDList;
        let tmpItem = {};
        console.log('HERE : ', this.props.paygoID);
        reportIDList.map(async (item, id) => {
            tmpItem = item;
            if (item.id === reportID) {
                if (comment) {
                    tmpItem.comments[0].comment = comment;
                    const currentDate = new Date();
                    const currentTime = currentDate.toTimeString().split(' ');
                    tmpItem.timeUpdate = `${currentDate.toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} à ${currentTime[0]}`;
                }
                if (status) {
                    const currentDate = new Date();
                    const currentTime = currentDate.toTimeString().split(' ');
                    tmpItem.timeUpdate = `${currentDate.toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} à ${currentTime[0]}`;
                    tmpItem.labels[0].val[0] = status;
                }
            }
            modifiedList[id] = tmpItem;
            // console.log('Modified List ::: ', modifiedList);
        });
        console.log('MODIFIED LIST ::: ', modifiedList, ' ::: ', this.state.reportIDList);
        this.setState({ edit: false, comment: '', status: '', reportID: '', reportIDList: modifiedList }, () => console.log('UPDATED reportIDList : ', reportIDList));
    }
    
    newSchema = () => {
        this.setState({popupSchema: true});
    }

    getUserNameFromBoxID = (boxID) => {
        const { CLIENTS } = this.props;
        var info = "";
        // Object.values(this.props.CLIENTS).map(client => {
        //     if (typeof client.resume !== "undefined"){
        //         if(client.resume.idBox===boxID ){
        //             console.log(client)
        //             info= client.resume.clientName
        //         }
        //     }
        // })
        if (!isEmpty(CLIENTS[boxID]) && !isEmpty(CLIENTS[boxID].resume) ){
            info = CLIENTS[boxID].resume.clientName
        }
        return info
    }
    getTechSchemas = async () => {
        try {
            const response = await fetch("/schema/maintenance/list", {
                method: 'GET',
                headers: {
                   'Content-Type': 'application/json',
                   //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
            });            
            const resp = await response.json();
            console.log(resp);
            this.setState({ schemasList: resp.content ? resp.content : [] });
        } catch (error) {
            console.log("[ERROR] GET TECH SCHEMAS LIST");
        }
    }
            
    setMessage = (notif) => {
        let { title, type, message } = notif;
        this.setState({
            notif:{
                type ,
                message,
                show: true
            },
        })
    }
    getLastAssignmentComment = (list) => {
        const affectations = list.filter(entry => entry.comment.includes("Attribué à"));
        if (!affectations.length) {
          return null;
        }
        const actual = affectations[affectations.length - 1];
        const lastComment = actual.comment;
        return lastComment;
      }
    render() {
        const { reportIDList, selected_report } = this.state;
        const { REPORTS, rowsPerPage, currentPage } = this.props;
		const { CLASSES } = this.props;

        console.log({REPORTS, selected_report})
        // console.log('boxOwnersIds in Reports : ', this.state.boxOwnersIds);
        return (
            <div>
                {this.state.notif.show &&
                    <Notif 
                    // title={this.state.notif.title} 
                        show={this.state.notif.show} 
                        type={this.state.notif.type} 
                        message={this.state.notif.message} 
                        close={() => this.setState({
                            notif:{
                                ...this.state.notif,
                                show: false
                            }
                        })} 
                    />
                }
                <TableLayout> 
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" className={this.state.sortByPaygoID} onClick={() => this.sortBy("Nom")}>Nom</TableCell>
                            <TableCell component="th" className={this.state.sortByPaygoID} onClick={() => this.sortBy("paygoId")}>Paygo ID</TableCell>
                            <TableCell component="th" className={this.state.sortByMood} onClick={() => this.sortBy("Mood")}>Humeur</TableCell>
                            {/* <TableCell component="th">Actions à effectuer</TableCell> */}
                            <TableCell component="th" className={this.state.sortByStatus} onClick={() => this.sortBy("labels")}>Statut</TableCell>
                            <TableCell component="th" className={this.state.sortByCreation} onClick={() => this.sortBy("timeCreation")}>Date de création</TableCell>
                            <TableCell component="th" className={this.state.sortByUpdate} onClick={() => this.sortBy("timeUpdate")}>Dernière mise à jour</TableCell>
                            <TableCell component="th" className={this.state.sortByComment} onClick={() => this.sortBy("comments")}>Dernier commentaire</TableCell>
                            <TableCell component="th">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    { reportIDList.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map( ID  => {
                        const boxReport = REPORTS[ID]
                        let frCreationDate = '';
                        let frUpdateDate = <Moment fromNow locale="fr">{boxReport.timeUpdate}</Moment>;
                        
                        if (frCreationDate.split(' à ').length === 1) {
                            frCreationDate = new Date(boxReport.timeCreation).toLocaleString('fr-FR');
                        } else {
                            frCreationDate = boxReport.timeCreation;
                        }
                        return (
                            <TableRow style={{ backgroundColor: COLORS[toClassState(boxReport.labels && boxReport.labels[boxReport.labels.length - 1].val)] }} hover key={ID}>
                                <TableCell onClick={() => this.setState({ showPopup: true, selected_report: boxReport })}>{boxReport.Nom}</TableCell>
                                <TableCell onClick={() => this.setState({ showPopup: true, selected_report: boxReport })}>{boxReport.paygoId}</TableCell>
                                <TableCell onClick={() => this.setState({ showPopup: true, selected_report: boxReport })}>{boxReport.Mood[0].val}</TableCell>
                                
                                <TableCell onClick={() => this.setState({ showPopup: true, selected_report: boxReport })}>
                                    {boxReport.comments && boxReport.comments[boxReport.comments.length - 1].val}
                                </TableCell>
                                <TableCell onClick={() => this.setState({ showPopup: true, selected_report: boxReport })}>
                                    {boxReport.labels && boxReport.labels[boxReport.labels.length - 1].val}
                                </TableCell>
                                <TableCell onClick={() => this.setState({ showPopup: true, selected_report: boxReport })}>{frCreationDate}</TableCell>
                                <TableCell onClick={() => this.setState({ showPopup: true, selected_report: boxReport })}>{frUpdateDate}</TableCell>
                                <TableCell onClick={() => this.setState({ showPopup: true, selected_report: boxReport })}>
                                    
                                    <RichText text={boxReport.comments[boxReport.comments.length - 1].comment} />
                                </TableCell>
                                <TableCell>
                                    <IconButton
                                        title="Editer"
                                        color="primary"
                                        onClick={(e) => this.edit(boxReport)}
                                        type="button"
                                    >
                                        <EditRounded />
                                    </IconButton>
                                    {/* <div style={{display: 'flex', justifyContent: 'space-between'}}> */}
                                        {/* { (!this.state.edit || boxReport.id !== reportID) && */}
                                        {/* } */}
                                        {/* { this.state.edit && boxReport.id === reportID &&
                                        <IconButton
                                            title="Valider"
                                            color="secondary"
                                            onClick={this.validateChanges}
                                            type="button"
                                            className="btn btn-default btn-icon waves-effect waves-circle waves-float"
                                        >
                                            <CheckRounded />
                                        </IconButton> */}
                                    {/* </div> */}
                                </TableCell>
                            </TableRow>
                        );
                    })}
                    </TableBody>
                    <TableFooterPagination
                        colSpan={8}
                        count={size(reportIDList)} 
                        onChangePage={this.props.onChangePage} 
                        initialPage={this.props.currentPage} 
                    />
                    {/* {this.state.sort &&
                    <TableFooterPagination
                        colSpan={8}
                        // items={reportIDList} 
                        count={size(reportIDList)} 
                        onChangePage={this.props.onChangePage} 
                        initialPage={this.props.currentPage} 
                    />
                    }
                    {!this.state.sort &&
                    <TableFooterPagination
                        colSpan={8}
                        // items={reportIDList} 
                        count={size(reportIDList)} 
                        onChangePage={this.props.onChangePage} 
                        initialPage={this.props.currentPage} 
                    />
                    } */}
                
                </TableLayout>
                { this.state.showPopup &&
                    <PopupInfo
                        closePopup={() => this.setState({ showPopup: false })}
                        comments={this.state.selected_report.comments}
                        audios={this.state.selected_report.audios || []}
                        // boxAssoId={this.props.paygoID} // here paygoID = assoId
                        boxAssoId={this.state.selected_report.boxAssoId} // here paygoID = assoId
                        boxOwnersIds={this.state.boxOwnersIds}
                        edit={() => this.setState({edit:true})}
                        getClientReports={this.props.getClientReports}
                        USER_INFO_LIST = {["USER", "FAMILY", "PROSPECT", "OTHER"]}
                        BOX_INFO_LIST = {["INSTALL", "BOX", "SYSTEM", "EQUIPEMENT"]}
                        PAYMENTS_INFO_LIST = {["RESUME", "LIST"]} 
                        SUIVI_INFO_LIST 
                        reports
                        default_tab = {"SUIVI"}
                                    
                    />
                }

                { this.state.edit &&
                    <EditForm
                        // newSchema={this.newSchema}
                        getTechSchemas={this.getTechSchemas}
                        schemasList={this.state.schemasList}
                        // reportIDList={this.state.reportIDList}
                        selected_report={this.state.selected_report}
                        onEdition={this.onEdit}
                        status={this.state.selected_report.labels[this.state.selected_report.labels.length - 1].val}
                        boxOwnersIds={this.state.boxOwnersIds}
                        setMessage={this.setMessage}
                        handleClose={() => this.setState({ edit: false })}
                    />
                }

                {/* { !this.state.sort && <Pagination items={this.state.reportIDList} onChangePage={this.onChangePage} /> }
                { this.state.sort && <Pagination items={this.state.reportIDList} onChangePage={this.onChangePage} /> } */}
            </div>
        );
    }
}
const mapStateToProps = (state) => ({
    CLIENTS: state.clients
});
export default connect( mapStateToProps )(ReportsList);
    